/* eslint-disable no-param-reassign */

import api from '@/services/api/customKey/customKey';
import Vue from 'vue'
export default {
  state: {
    taskList: [],
    templateConfig: {},
    tempComponents: {},
    templateList: [],
    project_id: '',
    sort: [
      {
        label: '升序',
        value: 'asc',
        icon: 'iconicon_ascending_order'
      },
      {
        label: '降序',
        value: 'desc',
        icon: 'iconicon_reverse_order'
      }
    ],
    count: [
      {
        label: '按任务数排序',
        value: 'quantity',
        icon: 'iconicon_field_management1'
      },
      {
        label: '按姓名A-Z排序',
        value: 'name',
        icon: 'iconicon_a_z'
      }
    ]
  },
  mutations: {
    SET_TASKLIST: (state, data) => {
      state.taskList = data
    },
    SET_PROJECTID: (state, data) => {
      state.project_id = data
    }
  },
  getters: {},
  actions: {
    getprojectTemplate({ commit, state, dispatch }, params) {
      return new Promise(async (resolve, reject) => {
        if (state.project_id == params.project_id) {
          resolve(state.templateList)
          return
        }
        state.project_id = params.project_id
        let result = await dispatch('changeHeadTemplate', params)
        resolve(result.data[0].template_standard_components)
      })
    },
    changeHeadTemplate({ commit, state, dispatch, rootState }, params) {
      return new Promise(async (resolve, reject) => {
        api
          .getprojectTemplate(params)
          .then((res) => {
            let sorting_rules = rootState['task/task'].queryMsg.sorting_rules
            let findKeys = (val) => {
              return sorting_rules.find((res) => res[val])
            }
            let keyArr =
              res && res.data && res.data.length > 0
                ? res.data[0].template_standard_components.map((res) => {
                    // if (res.is_show) {
                    //   res.width = 160
                    //   return true
                    // }
                    res.is_show = Boolean(res.is_show)
                    res.width = 160
                    return res
                  })
                : []
            keyArr.unshift(
              ...[
                {
                  key: 'RangeTime',
                  component_name_in_template: '截止日期',
                  code: 'start_time',
                  is_show: true,
                  width: 219
                },
                {
                  key: 'LevelStatus',
                  component_name_in_template: '优先级',
                  code: 'sort_rule',
                  is_show: true,
                  is_sort: Boolean(findKeys('优先级')),
                  sort: state.sort,
                  sort_value: findKeys('优先级')?.['优先级'],
                  getIcon() {
                    if (!this.sort_value) return
                    return this.sort.find((res) => res.value === this.sort_value).icon
                  },
                  width: 160
                },
                {
                  key: 'Executor',
                  component_name_in_template: '执行人',
                  code: 'executor',
                  is_show: true,
                  is_sort: Boolean(findKeys('执行人')),
                  sort: state.count,
                  sort_value: findKeys('执行人')?.['执行人'],
                  getIcon() {
                    if (!this.sort_value) return
                    return this.sort.find((res) => res.value === this.sort_value).icon
                  },
                  width: 160
                },
                {
                  key: 'Participant',
                  component_name_in_template: '参与人',
                  code: 'task_members_user',
                  is_show: true,
                  width: 160
                }
              ]
            )

            Vue.prototype.$set(state, 'templateList', keyArr)
            resolve(res)
          })
          .catch((err) => {
            console.log(err)
            reject(err)
          })
      })
    },
    getStandardComponents({ commit, state }, parmas) {
      return new Promise((resolve, reject) => {
        api
          .getAllComponent(parmas)
          .then((res) => {
            // 截止日期
            let rangeTime = require(`@/views/customKeyPage/components/rangeTime/index.js`)
            Vue.use(rangeTime.default('RangeTime'))
            // 优先级
            let levelStatus = require(`@/views/customKeyPage/components/levelStatus/index.js`)
            Vue.use(levelStatus.default('LevelStatus'))
            // 执行人
            let Executor = require(`@/views/customKeyPage/components/Object/Executor/index.js`)
            Vue.use(Executor.default('Executor'))
            // 参与人
            let participant = require(`@/views/customKeyPage/components/participant/index.js`)
            Vue.use(participant.default('Participant'))
            res.data.forEach((item) => {
              state.templateConfig[item.code] = {}
              state.templateConfig[item.code]['code'] = item.code
              state.templateConfig[item.code]['standard_component_name'] = item.standard_component_name
              state.templateConfig[item.code]['config'] = {}
              item.attributes.forEach((temp, index) => {
                Vue.component(item.attributes[index].attribute_name, () => import(`@/views/customKeyPage/configTemplate/${temp.attribute_name}`))
              })
              state.templateConfig[item.code].config = item.attributes
              let keyArr = item.code.split('.')
              let fn = require(`@/views/customKeyPage/components/${keyArr[1]}/${keyArr[2]}/index.js`)
              Vue.use(fn.default(item.code))
              // Vue.component(item.code, () => import(`@/views/customKeyPage/components/${keyArr[1]}/${keyArr[2]}`))
            })

            resolve(res)
          })
          .catch((err) => reject(err))
      })
    },
    addChecklist({ commit }, params) {
      return new Promise((resolve, reject) => {
        api
          .addChecklist(params)
          .then((res) => {
            resolve(res)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    updateKey({ commit, dispatch, state }, { params, config, data }) {
      let temp = {
        template_id: data.id,
        template_name: data.template_name,
        template_desc: data.template_desc,
        sort_rule_type_id: data.sort,
        template_standard_components: [
          {
            component_id_in_template: params.id || 0,
            component_code: params.component_code,
            component_name_in_template: params.component_name_in_template,
            component_desc_in_template: params.component_desc_in_template,
            sort: params.id ? params.sort : data.template_standard_components.length == 0 ? 0 : Math.max(...data.template_standard_components.map((res) => res.sort)) + 1,
            component_config_in_template: { ...config }
          }
        ]
      }
      data.template_standard_components.forEach((res) => {
        if (params.id && params.id === res.id) {
        } else {
          temp.template_standard_components.push({
            component_id_in_template: res.id,
            component_code: res.component_code,
            component_name_in_template: res.component_name_in_template,
            component_desc_in_template: res.component_desc_in_template,
            sort: res.sort,
            component_config_in_template: res.component_config_in_template
          })
        }
      })
      return api.updateTemplateInfo(temp)
    },
    deleteKey({ commit }, { params, data }) {
      let temp = {
        template_id: data.id,
        template_name: data.template_name,
        template_desc: data.template_desc,
        sort_rule_type_id: data.sort,
        template_standard_components: []
      }
      data.template_standard_components.forEach((res) => {
        if (res.id === params.id) {
        } else {
          temp.template_standard_components.push({
            component_id_in_template: res.id,
            component_code: res.component_code,
            component_name_in_template: res.component_name_in_template,
            component_desc_in_template: res.component_desc_in_template,
            sort: res.sort,
            component_config_in_template: res.component_config_in_template
          })
        }
      })
      return api.updateTemplateInfo(temp)
    },
    fliterParamsKey({ state }, { params, config, data }) {
      return new Promise((resolve, reject) => {
        let obj = {}
        let item = state.templateConfig[params.component_code].config
        if (item) {
          for (let key in item) {
            obj[key] = config[key] || item[key]
          }
        }
        resolve(obj)
      })
    }
  }
}
